// import React, { useState } from 'react';
// import solidbackgroundimg from "../assets/solidbackgroundimg.png";
// let resolution = window.RESOLUTION;
// if(window.innerWidth >= 1920 && window.innerHeight >= 1080){resolution = "FHD";}else{resolution = "HD";}
// const userAgent = navigator.userAgent.toLowerCase();
// if (userAgent.includes('webos') || userAgent.includes('lg') || userAgent.includes('web0s')) {
// resolution = 'FHD';
// }
// const TermsConditions = ({data}) => {
//     const [termsConditions, setTermsConditions] = useState(data);
//     const styles = {
//         TermsConditionsContainer: {
//           backgroundImage: `url(${solidbackgroundimg})`,
//           display: 'flex',
//           flexDirection: 'column',
//           background: '#000037',
//           width: '92vw',
//           height: '74vh',
//           backgroundSize: 'cover',
//           backgroundPosition: 'center', // Center the background image
//           backgroundRepeat: 'no-repeat', // Do not repeat the background image
//           color: '#D0D0D0',
//           fontSize: '18px',
//           overflow:'scroll',
//         },
//       };
//   return (
//     <div style={styles.TermsConditionsContainer}
//      dangerouslySetInnerHTML={{ __html: termsConditions }}/>
//   );
// };
// export default TermsConditions;

import React, { useEffect, useRef, useState } from "react";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import RowList from "./RowList"; // Import the RowList component
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import { event } from "jquery";
import LoaderScreen from "./LoaderScreen";

let resolution = window.RESOLUTION;

const TermsConditions = ({
  data,
  callback,
  handleRowListUpButton,
  HandleUpBTN,
  HandleDownBTN,
  shouldCloseMenu,
}) => {
  const [termsConditions] = useState(data);
  const containerRef = useRef(null);
  const [hasSentEvent, setHasSentEvent] = useState(false);

  useEffect(() => {
    // Matomo Event
    if (!hasSentEvent) {
      sendTestMatomoEvent({
        eventCategory: "Page",
        eventAction: "View",
        eventName: "TermsAndCondition",
        url: "terms-conditions",
      });
       setHasSentEvent(true);
    }
  }, []);

  const [state, setState] = useState({
    focusOnText: false, // Focus on text content
    shouldFocusToRowList: true, // Focus on row list
    shoudFocus: false,
    loading: true,
  });
  const { shouldFocusToRowList, focusOnText, shoudFocus, loading } = state;
  const customScrollbarStyles = `
    .custom-scrollbar::-webkit-scrollbar {
      width: 8px;
    }
    
    .custom-scrollbar::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 10px;
    }
    
    .custom-scrollbar::-webkit-scrollbar-thumb {
      background-color: #888;
      border-radius: 10px;
      border: 2px solid transparent;
      background-clip: content-box;
    }
    
    .custom-scrollbar::-webkit-scrollbar-thumb:hover {
      background-color: #555;
    }

    /* Firefox ke liye styles */
    .custom-scrollbar {
      scrollbar-width: thin;
      scrollbar-color: #888 rgba(0, 0, 0, 0.2);
    }
  `;

  const styles = {
    TermsConditionsContainer: {
      backgroundImage: `url(${solidbackgroundimg})`,
      display: "flex",
      flexDirection: "column",
      background: "#000037",
      width: "92vw",
      height: "74vh",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      color: "#D0D0D0",
      fontSize: "18px",
       overflowY: "auto", // <-- Enable vertical scroll
      overflowX: "hidden",
      outline: "none",
      paddingRight: "15px"
    },
  };

  const handleKeyDown = (event) => {
    console.log("Key pressed:", event.code);

    if (event.code === "ArrowDown") {
      // HandleDownBTN();
      setState((prevState) => ({
        ...prevState,
        shoudFocus: false,
        shouldFocusToRowList: false,
        focusOnText: true,
        // loading: false,
      }));
      if (containerRef.current) {
        containerRef.current.focus();
      }
      HandleDownBTN();
    } else if (event.code === "ArrowUp" && state.focusOnText) {
      const scrollTop = containerRef.current?.scrollTop || 0;
      console.log("scrollTop...", scrollTop);
      if (scrollTop === 0) {
        console.log("scrollTop..11111.", scrollTop);
        containerRef.current.blur();
        containerRef.current.removeEventListener("keydown", handleKeyDown);
        window.removeEventListener("keydown", handleKeyDown);
        setState((prevState) => ({
          ...prevState,
          shoudFocus: false,
          shouldFocusToRowList: true,
          focusOnText: false,
        }));
        HandleUpBTN();
      }
    } else if (event.code === "Backspace" && shouldFocusToRowList) {
      // callback1("HandleUPButton");
      console.log("Backspace pressed");
      // containerRef.current.blur();
      // containerRef.current.removeEventListener("keydown", handleKeyDown);
      // window.removeEventListener("keydown", handleKeyDown);
      setState((prevState) => ({
        ...prevState,
        shoudFocus: true,
        shouldFocusToRowList: false,
        focusOnText: false,
      }));
      window.removeEventListener("keydown", handleKeyDown);
    }
  };

  // useEffect(() => {
  //   window.addEventListener("keydown", handleKeyDown);

  //   return () => {
  //     // window.removeEventListener("keydown", handleKeyDown);
  //   };
  // }, [focusOnText]);

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      loading: false,
    }));
    if (shouldCloseMenu) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [focusOnText, shouldCloseMenu]);

  return (
    <div>
      <style>{customScrollbarStyles}</style>
      {loading && <LoaderScreen />}
      <div
        ref={containerRef}
        className="custom-scrollbar"
        style={{
          ...styles.TermsConditionsContainer,
          border: "none", // Highlight focus on text content
        }}
        onKeyDown={handleKeyDown}
        tabIndex={state.focusOnText ? -1 : 0} // Focus management
        dangerouslySetInnerHTML={{ __html: termsConditions }} // Render the Terms & Conditions text
      />
    </div>
  );
};

export default TermsConditions;
